import componentInitializer from "@/frontend/utils/componentInitializer"
import fetchWindowObject from "@/lib/fetchWindowObject"

componentInitializer(async () => {
  if ($("#checkout-voucher-form").length === 0) return

  const checkoutVoucher = {
    stripe: null,
    elements: null,
    card_fields: null,

    setupForm: async function () {
      // Initilizing stripe elements api
      const StripeLib = await fetchWindowObject("Stripe")
      this.stripe = StripeLib($('meta[name="stripe-key"]').attr("content"))
      this.elements = this.stripe.elements()
      const elementStyles = {
        base: {
          fontSmoothing: "antialiased",

          "::placeholder": {
            color: "#c2cbd3",
          },
          ":-webkit-autofill": {
            color: "#e39f48",
          },
        },
        invalid: {
          color: "#E25950",

          "::placeholder": {
            color: "#FFCCA5",
          },
        },
      }

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid",
      }

      const cardNumber = this.elements.create("cardNumber", {
        style: elementStyles,
        classes: elementClasses,
      })
      cardNumber.mount("#stripe-card-number")

      const cardExpiry = this.elements.create("cardExpiry", {
        style: elementStyles,
        classes: elementClasses,
      })
      cardExpiry.mount("#stripe-card-expiry")

      const cardCvc = this.elements.create("cardCvc", {
        style: elementStyles,
        classes: elementClasses,
      })
      cardCvc.mount("#stripe-card-cvc")

      this.card_fields = [cardNumber, cardExpiry, cardCvc]
      registerElements(this.card_fields, "stripe")

      return $("#checkout-voucher-form").submit(() => {
        $("#card-voucher-submit")
          .html("<i class='fas fa-sync-alt fa-fw fa-spin'></i> PROCESSING...")
          .attr("disabled", true)
        $("#paypal-voucher-submit")
          .html("<i class='fas fa-sync-alt fa-fw fa-spin'></i> REDIRECTING...")
          .attr("disabled", true)
        if (this.validateForm() == false) {
          $("#card-voucher-submit").html("PAY NOW").attr("disabled", false)
          $("#paypal-voucher-submit").html("PAY WITH PAYPAL").attr("disabled", false)
          return false
        } else {
          if ($(".payment-input:checked").val() == "paypal") {
            return true
          } else {
            this.processCard()
            return false
          }
        }
      })
    },
    validateForm: function () {
      let valid = true

      if (lanceUtilValidateInputRequire("#name-input") == false) {
        valid = false
      }
      if (lanceUtilValidateInputRequire("#email-input") == false) {
        valid = false
      }
      if (lanceUtilValidateInputRequire("#value-input") == false) {
        valid = false
      }
      if (lanceUtilValidateInputRequire("#recipient-name-input") == false) {
        valid = false
      }

      if ($(".send-to-input:checked").val() == "recipient") {
        if (lanceUtilValidateInputRequire("#recipient-email-input") == false) {
          valid = false
        }
      }

      return valid
    },
    processCard: function () {
      this.stripe.createToken(this.card_fields[0]).then(this.handleStripeResponse)
    },
    handleStripeResponse: function (result) {
      if (result.error) {
        this.setStripeError(result.error.message)
      } else {
        let $form = $("#checkout-voucher-form")
        const token = result.token.id

        if (!token || !token.length) {
          return this.setStripeError("Invalid token returned from server. Please contact customer support!")
        }
        // appending token input field to the form
        let $tokenInput = $form.find('input[name="stripe_card_token"]')
        if ($tokenInput.length == 0) {
          $tokenInput = $form.append("<input></input>")
        } else {
          $tokenInput = $tokenInput[0]
        }
        $tokenInput.setAttribute("type", "hidden")
        $tokenInput.setAttribute("name", "stripe_card_token")
        $tokenInput.setAttribute("value", token)
        $form.append($tokenInput)

        $form.get(0).submit()
      }
    },
    setStripeError: function (error) {
      // Show the errors on the form
      $("#stripe-error").removeClass("hidden")
      $("#stripe-error .message").html(error)
      $("#card-voucher-submit").html("PAY NOW").prop("disabled", false)
      $("#paypal-voucher-submit").html("PAY WITH PAYPAL").attr("disabled", false)
      $("html,body").animate({ scrollTop: $("#stripe-error").offset().top - 180 }, 500)
    },
  }

  await checkoutVoucher.setupForm()

  $(".send-to-input").on("change", function () {
    switch ($(this).val()) {
      case "me":
        $("#recipient-form-group").hide()
        break
      case "recipient":
        $("#recipient-form-group").show()
        break
      default:
        $(this).val("me")
        $("#recipient-form-group").hide()
    }
  })

  $(".payment-input").on("change", function () {
    $(".payment-form").hide()
    switch ($(this).val()) {
      case "card":
        $("#card-form").show()
        break
      case "paypal":
        $("#paypal-form").show()
        break
      default:
        $(this).val("card")
        $("#card-payment-submit-alias").show()
    }
  })

  $("input.voucher-type").on("change", function (event) {
    event.preventDefault()
    var selectedType = $(event.target).val()
    if (selectedType == "christmas") {
      $("#original-cover").addClass("hidden")
      $("#christmas-cover").removeClass("hidden")
    } else if (selectedType == "normal") {
      $("#christmas-cover").addClass("hidden")
      $("#original-cover").removeClass("hidden")
    }
  })
})
